import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { AlertService, AuthenticationService } from '../services';
import { Router } from '@angular/router';
import { AlertItem, AlertType } from '../models';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private refreshObservable: Observable<any> = null;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        const a = document.createElement('a');
        a.href = request.url;
        if (err.status === 401 && !['/accessToken', '/v1/auth/refresh'].includes(a.pathname)) {
          if (this.refreshObservable == null) {
            this.refreshObservable = this.authenticationService.refreshToken().pipe(
              catchError(error => {
                this.alertService.show(new AlertItem('disconnected', AlertType.warning, false, 10000));
                this.alertService.complete();
                this.authenticationService.logout();
                this.router.navigate(['/login']);
                return throwError(err);
              })
            );
          }
          return this.refreshObservable.pipe(
            mergeMap(resp => {
              request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${resp.accessToken}`) });
              return next.handle(request);
            })
          );
        }
        return throwError(err);
      })
    );
  }
}
